$(document).ready(function (event) {
  var quantity = 0;
  $(document).on('click touchstart', '.quantity-minus-svg-desktop', function (event) {
    $(this).css('pointer-events', 'none');
    $(this).parents('.cart-quntity-wrapper-desktop').find('.cart-quntity').val(parseInt($(this).parents('.cart-quntity-wrapper-desktop').find('.cart-quntity').val()) - 1);
    var itemQuantity = $(this).parents('.cart-quntity-wrapper-desktop').find('.cart-quntity').val();
    var itemKey = $(this).parents('.cart-quntity-wrapper-desktop').find('.cart-quntity').data('item-key');
    updateCart(itemQuantity, itemKey);
  });

  $(document).on('click touchstart', '.quantity-plus-svg-desktop', function (event) { console.log("qty change");
    $(this).css('pointer-events', 'none');
    // console.log($(this).parents('.cart-quntity-wrapper-desktop').find('.cart-quntity').val());
    $(this).parents('.cart-quntity-wrapper-desktop').find('.cart-quntity').val(parseInt($(this).parents('.cart-quntity-wrapper-desktop').find('.cart-quntity').val()) + 1);
    var itemQuantity = $(this).parents('.cart-quntity-wrapper-desktop').find('.cart-quntity').val();
    var itemKey = $(this).parents('.cart-quntity-wrapper-desktop').find('.cart-quntity').data('item-key');
    updateCart(itemQuantity, itemKey);
  });

  $(document).on('click touchstart', '.quantity-minus-svg-mobile', function (event) {
    $(this).css('pointer-events', 'none');
    $(this).parents('.cart-quntity-wrapper-mobile').find('.cart-quntity').val(parseInt($(this).parents('.cart-quntity-wrapper-mobile').find('.cart-quntity').val()) - 1);
    var itemQuantity = $(this).parents('.cart-quntity-wrapper-mobile').find('.cart-quntity').val();
    var itemKey = $(this).parents('.cart-quntity-wrapper-mobile').find('.cart-quntity').data('item-key');
    updateCart(itemQuantity, itemKey);
  });

  $(document).on('click touchstart', '.quantity-plus-svg-mobile', function (event) {
    $(this).css('pointer-events', 'none');
    // console.log($(this).parents('.cart-quntity-wrapper-mobile').find('.cart-quntity').val());
    $(this).parents('.cart-quntity-wrapper-mobile').find('.cart-quntity').val(parseInt($(this).parents('.cart-quntity-wrapper-mobile').find('.cart-quntity').val()) + 1);
    var itemQuantity = $(this).parents('.cart-quntity-wrapper-mobile').find('.cart-quntity').val();
    var itemKey = $(this).parents('.cart-quntity-wrapper-mobile').find('.cart-quntity').data('item-key');
    updateCart(itemQuantity, itemKey);
  });

  $(document).on('change', '.cart-quntity', function (event) {
    var itemQuantity = $(this).val();
    var itemKey = $(this).data('item-key');
    updateCart(itemQuantity, itemKey);
  });

  $(document).on('click', '[data-cart-item] .cart__remove a', function (event) {
    var itemQuantity = 0;
    var itemKey = $(this).data('item-key');
    updateCart(itemQuantity, itemKey);
  });

  // $(document).on('click', '.Button-custom-checkout', function (event) {
  //   if ($(this).is(':checked')) {
  //     $('.terms-condition-error').addClass('hide');
  //   } else {
  //     $('.terms-condition-error').removeClass('hide');
  //   }
  // });

  // $(document).on('change', '#terms-condition-checkbox', function (event) {
  //   if ($(this).is(':checked')) {
  //     $('.Button-custom-checkout').addClass('hide');
  //     $('.button-checkout').removeClass('hide');
  //     $('.terms-condition-error').addClass('hide');
  //   } else {
  //     $('.Button-custom-checkout').removeClass('hide');
  //     $('.button-checkout').addClass('hide');
  //   }
  // });
});
  
function updateCart(itemQuantity, itemKey) {
  $.ajax({
    url: '/cart/change.js',
    data: {
      quantity: itemQuantity,
      id: itemKey,       
    },
    type: 'POST',
    dataType: 'json',
    success: function(result) {
      var min_cart_value_for_giftcard = $('#gift-product-details #min_cart_value').val();
      var total_cart_value = result.total_price/100;
      var gift_product_id = $('#gift-product-details #product_id').val();
      if(gift_product_id != '' && min_cart_value_for_giftcard != '' && min_cart_value_for_giftcard > 0 && parseInt(min_cart_value_for_giftcard) <= total_cart_value && $('.cart-table [data-cart-item].gift_product').length < 1){
         $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: {"id": gift_product_id, "quantity": 1},
          success: function (response) { //console.log("success=", response);
            $.ajax({
              url: window.location.href,
              type: 'GET',
              success: function(result2) {
                $('.cart-table').html($(result2).find('.cart-table').html());
                $('.cart-subtotal').html($(result2).find('.cart-subtotal').html());
                $('.total_savings').html($(result2).find('.total_savings').html());
                $('.cart-count').text(result.item_count+response.quantity);
              },
              error: function (error) { console.log(error);
              }
            });                             
          },
          error: function (obj, status) { console.log("error=", status); },
        });
      } else if(gift_product_id != '' && min_cart_value_for_giftcard != '' && min_cart_value_for_giftcard > 0 && parseInt(min_cart_value_for_giftcard) > total_cart_value && $('.cart-table [data-cart-item].gift_product').length > 0){
        $.ajax({
          url: '/cart/change.js',
          data: {
            quantity: 0,
            id: gift_product_id,       
          },
          type: 'POST',
          dataType: 'json',
          success: function(response) {
            $.ajax({
              url: window.location.href,
              type: 'GET',
              success: function(result) {
                $('.cart-table').html($(result).find('.cart-table').html());
                $('.cart-subtotal').html($(result).find('.cart-subtotal').html());
                $('.total_savings').html($(result).find('.total_savings').html());
                if(response.item_count<1) {
                  $('.cart-count').text(response.item_count);
                  $('.cart-wrapper [data-cart-wrapper]').addClass('hide');
                  $('.cart-wrapper [data-empty-page-content]').removeClass('hide');
                } else { $('.cart-count').text(response.item_count); }
              },
              error: function (error) {
              
              }
            });   
          },
          error: function (error) {
          
          }
        });
      } else if(result.item_count<1) {
        $('.cart-count').text(result.item_count);
        $('.cart-wrapper [data-cart-wrapper]').addClass('hide');
        $('.cart-wrapper [data-empty-page-content]').removeClass('hide');
      } else {
        $.ajax({
          url: window.location.href,
          type: 'GET',
          success: function(result2) {
            $('.cart-table').html($(result2).find('.cart-table').html());
            $('.cart-subtotal').html($(result2).find('.cart-subtotal').html());
            $('.total_savings').html($(result2).find('.total_savings').html());
            $('.cart-count').text(result.item_count);
          },
          error: function (error) {
          
          }
        });
      }
    },
    error: function (error) {
    console.log(error);
    }
  });
}